export class SessionInfo {
  constructor(
    public username: string,
    public token: string,
    public expiresIn: number
  ) {}
}
